import DashboardTwoToneIcon from '@material-ui/icons/DashboardTwoTone';
import PostAddTwoToneIcon from '@material-ui/icons/PostAddTwoTone';
import ScheduleTwoToneIcon from '@material-ui/icons/ScheduleTwoTone';
import SubscriptionsTwoToneIcon from '@material-ui/icons/SubscriptionsTwoTone';
import AccountBoxTwoToneIcon from '@material-ui/icons/AccountBoxTwoTone';
import ExitToAppTwoToneIcon from '@material-ui/icons/ExitToAppTwoTone';
import ReceiptTwoToneIcon from '@material-ui/icons/ReceiptTwoTone';
import { ROLE_TYPE, MENU_LABEL } from '../../constants';
import { ROUTES_PATH_CONFIG } from '../../config/routes';


export default {
    [ROLE_TYPE.VENDOR]: {
        label: MENU_LABEL,
        content: [
            {
                "label": "Dashboard",
                "icon": DashboardTwoToneIcon,
                "to": ROUTES_PATH_CONFIG.VENDOR.dashboard
            },
            {
                "label": "Posts",
                "icon": PostAddTwoToneIcon,
                "open": true,
                "content": [
                    {
                        "label": "Recommended",
                        "icon": PostAddTwoToneIcon,
                        "to": "/v/posts/recommended"
                    },
                    {
                        "label": "Applied",
                        "icon": PostAddTwoToneIcon,
                        "to": "/v/posts/applied"
                    }
                ]
            },
            {
                "label": "RFQ",
                "icon": ReceiptTwoToneIcon,
                "to": "/v/rfqs"
            },
            {
                "label": "Meeting Invites",
                "icon": ScheduleTwoToneIcon,
                "to": "/v/meeting_invites"
            },
            {
                "label": "Work & Rates",
                "icon": SubscriptionsTwoToneIcon,
                "to": "/v/rates"
            },
            {
                "label": "Account",
                "icon": AccountBoxTwoToneIcon,
                "showInUserBox": true,
                "content": [
                    {
                        "label": "Subscription",
                        "icon": SubscriptionsTwoToneIcon,
                        "to": "/v/subscription"
                    },
                    {
                        "label": "Work & Rates",
                        "icon": SubscriptionsTwoToneIcon,
                        "to": "/v/rates"
                    },
                    {
                        "label": "Profile",
                        "icon": AccountBoxTwoToneIcon,
                        "to": "/v/profile"
                    },
                    {
                        "label": "Sign Out",
                        "icon": ExitToAppTwoToneIcon,
                        "to": ROUTES_PATH_CONFIG.APP.signout
                    }
                ]

            }
        ]
    }

};
